import React from 'react'
import CalendarWeek from 'pages/app/vacation/partials/CalendarWeek'
import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'

export default function CalendarWeeks () {
  const weeks = () => {
    const modelPeriod = useValue('period')

    const period = {
      from: modelPeriod && modelPeriod.from ? moment(modelPeriod.from) : moment().startOf('isoWeek'),
      to: modelPeriod && modelPeriod.to ? moment(modelPeriod.to) : moment().add(1, 'year')
    }

    let currentWeek = period.from.startOf('isoWeek')
    let to = period.to

    const weeks = []

    while (currentWeek <= to) {
      weeks.push(currentWeek.clone())
      currentWeek = currentWeek.add('1', 'week')
    }

    return weeks.map((week) => {
      return (
        <CalendarWeek
          week={week.isoWeek()}
          month={week.format('MMM')}
          startOfWeek={week.toDate()}
        />
      )
    })
  }

  return (
    <>
      {weeks()}
    </>
  )
}
